import Vue from 'vue'
import App from './App.vue'
import router from './router';
import QuestionsToolbar from './components/QuestionsToolbar';
import Question from './components/Question';
import Answer from './components/Answer';
import MainToolbar from './components/MainToolbar'
import Loading from './components/Loading'
import LottiePlayer from 'lottie-player-vue';
import VueAwesomeSwiper from 'vue-awesome-swiper'

// import style (>= Swiper 6.x)
import 'swiper/swiper-bundle.css'

Vue.use(VueAwesomeSwiper)

if ("serviceWorker" in navigator) {
    window.addEventListener("load", function() {
        navigator.serviceWorker
            .register("/serviceWorker.js")
            .then(() => console.log("service worker registered"))
            .catch(err => console.log("service worker not registered", err))
    })
}

require('./pollyfill');

import 'bootstrap';

Vue.config.productionTip = false

Vue.component('Loading', Loading);
Vue.component('QuestionsToolbar', QuestionsToolbar);
Vue.component('Question', Question);
Vue.component('Answer', Answer);
Vue.component('MainToolbar', MainToolbar);
Vue.use(LottiePlayer);

new Vue({
    ...App,
    router
}).$mount('#app')
